import { Modal } from 'src/components';
import styled from 'styled-components';

const FormModalStyle = styled(Modal)`
  &.modal-form {
    .ant-form-item-required {
      display: flex;
      flex-direction: row-reverse;
      justify-content: start;
      gap: 2px;
    }
    @media only screen and (max-width: 700px) {
      .col-avatar {
        display: none;
      }
      .col-form {
        min-width: 100%;
      }
    }
  }

  .ant-tabs-tab-btn .error {
    color: red;
  }
`;

export default FormModalStyle;
